/**
 * Ввод канала Telegram на карточке интеграции.
 *
 * Бэкенд понимает `@name`, `t.me/name` и числовой id `-100…`. У закрытого канала имени нет, а id
 * пользователь найти не умеет — зато видит его в адресной строке web.telegram.org, когда открывает
 * канал. Поэтому такой адрес принимаем целиком и достаём id сами:
 *
 * - `web.telegram.org/a/#-1001234567890` — версия A пишет id полностью;
 * - `web.telegram.org/k/#-1234567890` — версия K пишет id без `-100`, его надо дописать.
 *
 * Ссылка-приглашение `t.me/+…` / `t.me/joinchat/…` каналом не является: по ней бот канал не найдёт.
 */

const WEB_TELEGRAM_RE = /^(?:https?:\/\/)?web\.telegram\.org\/([a-z])\/?#(-?\d+)/i;
const INVITE_LINK_RE = /^(?:https?:\/\/)?(?:t\.me|telegram\.me)\/(?:\+|joinchat\/)/i;

/** Префикс Bot API для каналов и супергрупп: id `123` превращается в `-100123`. */
const CHANNEL_ID_PREFIX = '-100';

/** Ссылка-приглашение закрытого канала — её бэкенду отправлять бессмысленно. */
export function isTelegramInviteLink(input: string): boolean {
  return INVITE_LINK_RE.test(input.trim());
}

/**
 * Приводит ввод к тому, что понимает бэкенд. Адрес web.telegram.org → числовой id канала,
 * всё остальное (`@name`, `t.me/name`, `-100…`) уходит как есть, без пробелов по краям.
 */
export function normalizeTelegramChannelInput(input: string): string {
  const value = input.trim();
  const match = value.match(WEB_TELEGRAM_RE);
  if (!match) return value;

  const id = match[2];
  if (id.startsWith(CHANNEL_ID_PREFIX)) return id;
  // Версия K и всё прочее без `-100`: дописываем префикс к модулю id.
  return `${CHANNEL_ID_PREFIX}${id.replace(/^-/, '')}`;
}
